export default {
  name: 'number-picker',

  props: {
    value: { type: Number },
    min: { type: Number },
    max: { type: Number },
    label: { type: String },
  },

  data () {
    return {
      current: this.value || 0
    }
  },

  watch: {
    value (val) {
      this.current = val
    },

    current (val) {
      if(this.min !== undefined) val = Math.max(val, this.min)
      if(this.max !== undefined) val = Math.min(val, this.max)
      this.current = val
      this.$emit('input', val)
    }
  },
}
